import axios from "../Config/index";

const ServiceOrganizationRoute = {
  GetOrganizationData: (orgUuid) =>
    axios.get("/service-organization/organization/" + orgUuid),
};
export default ServiceOrganizationRoute;
